<script setup lang="ts">
import { useTemplateRef } from 'vue';

import { Tooltip } from '@/shared/ui';

import { useEmojiPickerState } from './emoji-picker-state';

const opened = defineModel<boolean>('opened', { default: false });
const { reference } = defineProps<{ reference: HTMLElement | null }>();
const emit = defineEmits<{
  (e: 'hover:enter'): void;
  (e: 'hover:leave'): void;
  (e: 'select', emoji: string): void;
}>();

const host = useTemplateRef<HTMLElement>('host');

const { pickerContentMounted } = useEmojiPickerState(
  host,
  (emoji: string): void => emit('select', emoji),
  opened,
);
</script>

<template>
  <Tooltip
    v-if="reference && pickerContentMounted"
    v-model:opened="opened"
    :reference="reference"
    strategy="fixed"
    teleport="body"
    close-on-click-outside
    close-on-scroll
    content-class="min-w-[18rem] max-w-[30rem] overflow-hidden border-1 border-[var(--theme-surface-muted)] p-0"
  >
    <template #content>
      <div
        ref="host"
        @mouseenter="emit('hover:enter')"
        @mouseleave="emit('hover:leave')"
      />
    </template>
  </Tooltip>
</template>
